module.exports = {
    header: `
    border-left: 6px solid gold;
    font-family: Helvetica;
    font-weight: bold;
    font-size: 14px;
    line-height: 26px;
    display: block;
    padding-left: 8px;
  `,

    sub: `
    font-family: Helvetica;
    font-size: 13px;
    line-height: 16px;
  `,

    dump: `
    font-family: Helvetica;
    font-size: 13px;
    line-height: 18px;
  `,

    group: `
    font-family: Helvetica;
    font-size: 13px;
    line-height: 28px;
    font-weight: normal;
    border-left: 9px solid royalblue;
    padding-left: 8px;
    color: #333;
  `,

    action: `
    font-family: Helvetica;
    font-size: 13px;
    line-height: 26px;
    font-weight: normal;
    color: #000;
    border-left: 6px solid green;
    padding: 0 0 0 8px;
  `,

    output: `
    font-family: Helvetica;
    font-size: 11px;
    line-height: 26px;
    font-weight: normal;
    color: #000;
  `
};



// WEBPACK FOOTER //
// ./services/history/styles.js